// extracted by mini-css-extract-plugin
export default {"tabPanelRoot":"itemScreenTabs_tabPanelRoot__QuQmo"};